import { Typography, Box, Container, Fade, Button } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import style from "../../Styles/commonWrongQuestions.module.css";
import genericStyle from "../../Styles/genericStyles.module.css";
import { useEffect, useState } from "react";
import { getData } from "../../Services/getData";
import { endpoints, localUrlEnum } from "../../Utils/UrlEnum";
import QuestionCollapsable from "./QuestionsCollapsable";
import { useNavigate } from "react-router-dom";
import { PlayArrow } from "@mui/icons-material";

export default function CommonWrongQuestions() {
  const clientId = localStorage.getItem("clientId");
  const navigate = useNavigate();
  const [wrongQuestions, setWrongQuestions] = useState<[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData(`${endpoints.examQuestions.commonWrongQuestions}/${clientId}`).then(
      (res: any) => {
        if (res && res.data) {
          setWrongQuestions(res.data);
        }
        setLoading(false);
      }
    );
  }, [clientId]);

  const handleStartPracticeExam = () => {
    // Extract the question data from the wrong questions structure
    const practiceQuestions = wrongQuestions.map((item: any) => item.question || item);

    // Navigate to exam page passing the wrong questions as state
    navigate(localUrlEnum.examQuestions, {
      state: { practiceQuestions, isPracticeMode: true },
    });
  };

  return (
    <div className={genericStyle.scrollableContainer}>
      <Box className={style.mainContainer}>
        <Container maxWidth="xl" className={style.questionsContainer}>
          <Fade in={!loading} timeout={800}>
            <Box>
              <Box className={style.headerSection}>
                <Box>
                  <Typography
                    variant="h2"
                    className={`${style.mainTitle} ${genericStyle.titleColor}`}
                  >
                    {Vocabulary.commonWrongQuestions}
                  </Typography>
                  <Typography variant="body1" className={style.subTitle}>
                    {Vocabulary.commonWrongQuestionsExplanation}
                  </Typography>
                </Box>
                {wrongQuestions.length > 0 && (
                  <Button
                    variant="contained"
                    startIcon={<PlayArrow />}
                    onClick={handleStartPracticeExam}
                    className={style.practiceButton}
                    disabled={loading}
                  >
                    Exerseaza-le din nou
                  </Button>
                )}
              </Box>

              <Box className={style.questionsCollapsable}>
                <QuestionCollapsable questions={wrongQuestions} />
              </Box>
            </Box>
          </Fade>
        </Container>
      </Box>
    </div>
  );
}
